import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["id", "accept", "multiple"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createElementBlock("div", {
    class: "upload-button",
    disabled: $props.loading
  }, [
    _createElementVNode("input", {
      id: $data.input_id,
      ref: "input",
      type: "file",
      accept: $props.accept,
      style: {"display":"none"},
      multiple: $props.multiple ? true : undefined,
      onClick: _cache[0] || (_cache[0] = ev => ev.target.value = null),
      onChange: _cache[1] || (_cache[1] = ev => _ctx.$emit('upload', ev.target.files))
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
    ($props.type == 'icon')
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          hoverable: "",
          class: "upload-icon pointer",
          stroke: "var(--gray-700)",
          icon: $props.icon,
          width: "2rem",
          height: "2rem",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.$refs.input.click()))
        }, null, 8 /* PROPS */, ["icon"]))
      : (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          ref: "button",
          primary: $props.primary,
          style: {"width":"100%"},
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.$refs.input.click()))
        }, {
          default: _withCtx(() => [
            ($props.loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  color: $options.loader_color,
                  mini: "",
                  inline: "",
                  style: {"width":"1.8rem"}
                }, null, 8 /* PROPS */, ["color"]))
              : (_openBlock(), _createBlock(_component_Icon, {
                  key: 1,
                  class: "upload-icon",
                  stroke: $props.stroke,
                  icon: $props.icon,
                  width: "1.8rem",
                  height: "1.8rem"
                }, null, 8 /* PROPS */, ["stroke", "icon"])),
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _cache[4] || (_cache[4] = _createTextVNode(" Upload "))
            ], true)
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["primary"]))
  ], 8 /* PROPS */, _hoisted_1))
}